import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function useInactivityTimer() {
    const location = useLocation();
    const [inactive, setInactive] = useState(false);

    useEffect(() => {
        let timeout = setTimeout(() => {
            setInactive(true);

        }, 4 * 60 * 60 * 1000); // 4 hours

        return () => clearTimeout(timeout); // Clear the timer when route changes
    }, [location.pathname]); // Reset timer on every route change

    return [inactive, setInactive]
}
